import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, HostListener, OnInit, Renderer2, ViewChild, ViewChildren } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
} from '@angular/forms';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { NotifyType } from '../../enums/NotifyType';
import { AppNotifyService } from '../../services/app-notify.service';
import { CartService } from '../../services/cart.service';
import { UserService } from '../../services/user.service';
import { tap } from 'rxjs/operators';
import { IUser, ILoginRequest, IChangeCustomer, ICustomerSuggestion, IUserLogin, IHeaderLabels, IPWALoginRequest } from '../../models';
import { CustomerService } from '../../services/customer.service';
import { BehaviorSubject, Subscription } from 'rxjs';
import { SignalRService } from '../../services/signal-r.service';
import { LanguageTranslationService } from '../../services/language-translation.service';
import { Info } from '../../common';
import { DeviceDetectorService, DeviceInfo } from "ngx-device-detector";

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  header: IHeaderLabels;
  displayMessage: boolean;
  isVisibleManageCompany: boolean = false;
  canManageAddress: any;
  scrHeight: any;
  scrWidth: any;
  isMobile: boolean;
  openedwarningMessage: boolean;
  deviceInfo: DeviceInfo = null;
  public get loggedInUser(): IUser {
    return this.userService.readUserObject;
  }
  @ViewChild('t', { static: false }) dummy: ElementRef;
  //(start) Afsana Dec 5th 2023 visual password requirements code changes
  @ViewChild('passwordMatchIcon', { static: false }) passwordMatchIcon: ElementRef; 
  @ViewChild('upperCaseIcon', { static: false }) upperCaseIcon: ElementRef;
  @ViewChild('lowerCaseIcon', { static: false }) lowerCaseIcon: ElementRef;
  @ViewChild('numberIcon', { static: false }) numberIcon: ElementRef;
  @ViewChild('specialCharacterIcon', { static: false }) specialCharacterIcon: ElementRef;
  @ViewChild('minLengthIcon', { static: false }) minLengthIcon: ElementRef;
  ///(end) Afsana Dec 5th 2023 visual password requirements code changes

  //#region change customer 
  public filteredCustomerItems: IChangeCustomer[];
  public currentInputValueInItemSearch: string;
  public customerSearchLoading: BehaviorSubject<boolean> = new BehaviorSubject(
    false
  );
  public changeCustomerForm: FormGroup = new FormGroup({
    customerName: new FormControl(''),
  });

  //#endregion
  public inProgressMessage: boolean;
  public successMessage: boolean;
  public errorMessage: boolean;
  public saveNewPasswordInProcess: boolean;
  public infoMessage: Info = new Info();
  constructor(
    private fb: FormBuilder,
    private forgotPasswordEmail: FormBuilder,
    private forgotPasswordOtp: FormBuilder,
    private router: Router,
    private cookieService: CookieService,
    private appNotifyService: AppNotifyService,
    private cartservice: CartService,
    private userService: UserService,
    private customerService: CustomerService,
    private cartService: CartService,
    private signalRService: SignalRService,
    private languageTranslation: LanguageTranslationService,
    private deviceService: DeviceDetectorService,
    private forgotUsernameEmail: FormBuilder,
    private renderer: Renderer2, //Afsana Dec 5th 2023 visual password requirements code changes
  ) {
   
    this.getScreenSize();
  }

  safeClick(el: HTMLElement | null | undefined) {
    el?.click?.();
  }


  public countOfCartItemsFromService: number;

  // Animation for User Profile
  public get animate(): any {
    if (this.enabled) {
      return {
        type: this.type,
        direction: this.direction,
        duration: this.duration,
      };
    }
    return false;
  }

  public get hasDirection(): boolean {
    return this.type === 'slide' || this.type === 'expand';
  }

  // User Profile Password Change
  public passwordForm: FormGroup;
  public defaultPasswordForm: FormGroup;
  public changePasswordByOTPForm: FormGroup;
  public userId: any = ''; // shows user name based on Sign In.
  public userPassword = '';//
  public showMenu = false; // shows or hides main menu based on user sign In.
  public showSpacer = true;
  public showLoginBridgeBlock = true;
  public showSearch = false; // shows Search field based on user sign In
  public showGreeting = false; // shows name of user id based on sign in user id
  public showLanguage = false; // show kendo popup
  public showSignIn = false; // show kendo popup
  public userLoggedInSuccess = false; // show kendo popup for logged in
  public userLoggedOutSuccess = false;
  public userLoggedInFail = false;
  public showProfile = false; // shows and hides profile popup
  public changeCustomerDialog = false;
  public openedPassword = false; // manage password dialog
  public openedForgotPassword = false; // forgot password dialog
  public openedForgotPasswordConfirmation = false; // forgot password confimation dialog
  public openedForgotPasswordOtp = false;
  public openedForgotPasswordOtpSuccess = false;
  public changedSuccess = false;
  public changedFailed = false;

  // Forgot Password Email Confirmation
  public forgotPasswordForm: FormGroup;
  public submitted = false;
  // END Forgot Password Email Confirmation

  // Forgot Password Otp Confirmation
  public forgotPasswordOtpForm: FormGroup;
  public submittedOtp = false;
  public forgetPasswordInProcess = false;
  // END Forgot Password Otp Confirmation

  public signInText = true; // sign in link shows and hides based on user sign in
  public signOutText = false; // sign out link shows and hides based on user sign in
  public openedProfile = false; // shows and hides profile dialog
  public showProfileIcon = false; // shows and hides profile icon
  public showCart = false; // shows and hides shopping cart.

  //change customer popup variables
  public showSuggestionBox: boolean;
  //public currentInputValueInItemSearch: string;
  // Kendo Animation for popups
  public enabled = true;
  public duration = 200;
  public type = 'slide';
  public direction = 'left';
  public title: string;
  public opened = true;

  public broadCastMessage: string;

  // Language Options
  public languages = [
    {
      id: 'eng',
      value: 'eng',
      image:
        '../../../assets/images/flag-icons/32_pixels/united-states-of-america-flag-icon-32.png',
    },
    {
      id: 'fre',
      value: 'fre',
      image:
        '../../../assets/images/flag-icons/32_pixels/france-flag-icon-32.png',
    },
  ];

  // Language Sign In
  signInLanguage = [{ eng: 'Sign In' }, { fre: 'Se connecter' }];

  signInLanguageLabel: string;

  // Language Sign Out
  signOutLanguage = [{ eng: 'Sign Out' }, { fre: 'DÃ©connexion' }];

  signOutLanguageLabel: string;

  // Language User User Id
  userIdLanguage = [{ eng: 'Username' }, { fre: '\'Nom d\'utilisateur\'' }];

  userIdLanguageLabel: string;

  // Language User Password
  passWordLanguage = [{ eng: 'Password' }, { fre: 'Mot de passe' }];

  passWordLanguageLabel: string;

  // Language Forgot Password
  forgotPassWordLanguage = [
    { eng: 'Forgot Password' },
    { fre: 'Mot de passe oubliÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â©' },
  ];

  forgotPassWordLanguageLabel: string;

  // Language for Forgot Password Dialog
  forgotPasswordEmailConfirmationLanguage = [
    {
      eng:
        'Enter the email address associated with your Kawneerdirect account.',
    },
    {
      fre:
        'Entrez \'adresse e-mail associÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â©e ÃƒÆ’Ã†â€™  votre compte Kawneerdirect.',
    },
  ];

  forgotPasswordEmailConfirmationLanguageLabel: string;

  // language for Forgot Password Dialog Continue button

  // Language New user
  continueButtonLanguage = [{ eng: 'Continue' }, { fre: 'Continuer' }];

  continueButtonLanguageLabel: string;

  // Language Reset
  resetButtonLanguage = [{ eng: 'Cancel' }, { fre: 'Annuler' }];

  resetButtonLanguageLabel: string;

  // Language New user
  newUserLanguage = [{ eng: 'New user' }, { fre: 'Nouvel utilisateur' }];

  newUserLanguageLabel: string;

  // Set Languages English and French using Local Storage
  languageList: any;
  public setLanguage(id) {
    localStorage.setItem('language', id);
    this.languageList = JSON.parse(localStorage.getItem("LanguageTextV2"));
    if (this.languageList) {
      var list = this.languageList.filter(r => r.languageCode === id);
      if (list.length < 1) {
        this.setLanguageDataInLocalstorage();
      }
      else {
        window.location.reload();
      }
    }

    //this is old code
    //if (localStorage.getItem('language') === 'eng' || 1 === 1) {
    //  this.signInLanguageLabel = this.signInLanguage[0].eng;
    //  this.signOutLanguageLabel = this.signOutLanguage[0].eng;
    //  this.userIdLanguageLabel = this.userIdLanguage[0].eng;
    //  this.passWordLanguageLabel = this.passWordLanguage[0].eng;
    //  this.forgotPassWordLanguageLabel = this.forgotPassWordLanguage[0].eng;
    //  this.forgotPasswordEmailConfirmationLanguageLabel = this.forgotPasswordEmailConfirmationLanguage[0].eng;
    //  this.newUserLanguageLabel = this.newUserLanguage[0].eng;
    //  this.continueButtonLanguageLabel = this.continueButtonLanguage[0].eng;
    //  this.resetButtonLanguageLabel = this.resetButtonLanguage[0].eng;
    //  localStorage.setItem('language', this.languages[0].id);
    //} else {
    //  this.signInLanguageLabel = this.signInLanguage[1].fre;
    //  this.signOutLanguageLabel = this.signOutLanguage[1].fre;
    //  this.userIdLanguageLabel = this.userIdLanguage[1].fre;
    //  this.passWordLanguageLabel = this.passWordLanguage[1].fre;
    //  this.forgotPassWordLanguageLabel = this.forgotPassWordLanguage[1].fre;
    //  this.forgotPasswordEmailConfirmationLanguageLabel = this.forgotPasswordEmailConfirmationLanguage[1].fre;
    //  this.newUserLanguageLabel = this.newUserLanguage[1].fre;
    //  this.continueButtonLanguageLabel = this.continueButtonLanguage[1].fre;
    //  this.resetButtonLanguageLabel = this.resetButtonLanguage[1].fre;
    //  localStorage.setItem('language', this.languages[1].id);
    //}

  }
  onKey(value: string) {
    this.userId = value + '';
  }

  public onToggleSignIn(): void {
    this.showSignIn = !this.showSignIn;
  }

  disableChangePaswordSave = true;
  public checkChangePasswordSave() {
    if (this.validateNewPasswordForm()) {
      this.disableChangePaswordSave = false;
    }
    else {
      this.disableChangePaswordSave = true;
    }
  }

  public savePassword(): void {
    this.changePasswordDialog.isSubmitted = true;
    if (!this.validateNewPasswordForm()) {
      return;
    }
    this.infoMessage = new Info();
    this.inProgressMessage = true;
    this.saveNewPasswordInProcess = true;
    this.infoMessage.genericInProgress = this.infoMessage.inProgressMessage;
    const controls = this.passwordForm.controls;
    const body = {
      oldPassword: controls.oldPassword.value,
      newPassword: controls.newpassword.value,
      confirmPassword: controls.confirmpassword.value,
      userName: this.userService.readUserObject.userName
    }
    this.userService.ChangePassword(body).subscribe((response: any) => {
      //if (response) {
      //  this.openedProfile = !this.openedProfile;
      //  this.appNotifyService.notify(NotifyType.SUCCESS, 'Password Changed successfully');
      //  //this.changedSuccess = true;
      //  this.router.navigate(['home']);
      //} else {
      //  this.changedFailed = true;
      //}
      this.infoMessage.genericInProgress = "";
      this.saveNewPasswordInProcess = false;
      if (response) {
        this.infoMessage.genericSuccess = this.headerText.passwordChangeSuccessfulLbl;
        this.passwordForm.reset();
        this.disableChangePaswordSave = true;
      } else {
        this.infoMessage.genericError = this.headerText.passwordFailedLbl;
      }
    })
  }

  public closePassword(): void {
    this.openedPassword = !this.openedPassword;
  }

  //#region Change Customer dialog
  public closeChangeCustomerDialog(): void {
    this.changeCustomerDialog = false;
  }
  public openChangeCustomerDialog(): void {
    this.changeCustomerDialog = true;
    this.showProfile = !this.showProfile;
  }
  //#region manage company
  public closeProfile(): void {
    this.showProfile = !this.showProfile;
  }
  //#endregion

  splitText(eachItem: string) {
    if (this.currentInputValueInItemSearch.length === 1) {
      return eachItem.split('');
    }
    const regexString: string =
      this.currentInputValueInItemSearch +
      '|[^' +
      this.currentInputValueInItemSearch +
      ']|[0-9]|[a-z]';
    const regexConstructor: RegExp = new RegExp(regexString, 'gi');
    return eachItem.match(regexConstructor);
  }

  handleCustomerFilter(searchQuery: any) {
    const searchString = searchQuery;
    if (searchQuery.length > 0) {
      searchQuery = searchQuery.toUpperCase();
      this.showSuggestionBox = false;
      this.customerSearchLoading.next(true);
      this.currentInputValueInItemSearch = searchQuery;
      this.customerService.getSuggestion(searchString)
        .subscribe((data: ICustomerSuggestion[]) => {
          this.filteredCustomerItems = data;
          this.customerSearchLoading.next(false);
          this.showSuggestionBox = true;
        });
    } else {
      this.showSuggestionBox = false;
      this.customerService.searchCustomer.searchQuery = '';
      this.customerService.searchCustomer.customerNumber = '';
    }
    //if (searchQuery.length > 0) {debugger
    //  const tempArray = this.filteredCustomerItems;
    //  if (!isNaN(searchQuery)) {
    //    this.filteredCustomerItems = tempArray.filter((s) => s.customerNumber===(searchQuery));
    //  }
    //  else {
    //    this.filteredCustomerItems = tempArray.filter((s) => s.customerName.toLowerCase().indexOf(searchQuery.toLowerCase()) !== -1);
    //  }
    //}
    //else {
    //  this.getAllCustomers();
    //}

  }
  onClosecustomerChange(event) {
    this.filteredCustomerItems = this.customerDropdownData;
  }
  customerDropdownData: ICustomerSuggestion[];
  public getAllCustomers() {
    this.customerService.getSuggestion('').subscribe(response => {
      this.customerDropdownData = response;
      this.filteredCustomerItems = this.customerDropdownData;
    });
  }
  selectedCustomer: any;
  public customerChangeSelected(event) {
    this.selectedCustomer = event.customerNameToDisplay;
    // this.changeCustomerDialog = false;
  }


  changeCustomerSubmit() {
    //const selectedCustomer = this.changeCustomerForm.controls.customerName.value;

    console.log(this.selectedCustomer);
 
    const customer = (this.filteredCustomerItems as ICustomerSuggestion[]).find(x => x.customerNameToDisplay === this.selectedCustomer);

    if (customer) {
      const userObject = this.userService.readUserObject;
      userObject.customerNumber = customer.customerNumber;
      userObject.customerName = customer.customerName;
      userObject.paymentTerms = customer.paymentTerms;
      userObject.currencyCode = customer.currencyCode;
      userObject.countryCode = customer.country;
      //userObject.isCSCAccount = true;??
      //this.loggedInUser.customerName = customer.customerName;
      if (userObject) {
        this.userService.saveUserObject(userObject);
        this.router.navigate(['home']);
        this.cartService.getItemCountInCart().subscribe();
      }
    } else {
      //this.appNotifyService.notify(NotifyType.ERROR,"Could not find the Customer!")
    }
    this.filteredCustomerItems = this.customerDropdownData;
  }
  //#endregion


  public newUser(): void {
    this.showSignIn = false;
    document.getElementById('sign-in-dropdown').style.display = 'none';
  }


  public loginAttemptMessage: string;
  public showLoginAttempt: boolean = false;
  public invalidUserCredential: string;


  //#region storing language translation data in localstorage
  responseData: any;
  setLanguageDataInLocalstorage() {
    const body = {
      languageCode: localStorage.getItem('language')
    }
    this.languageTranslation.getLanguageLabel(body).subscribe(response => {
      if (response) {
        var isLanguageExist = localStorage.getItem('LanguageTextV2'); //checking whether eng/fre language data is already stored in localstorage 
        if (isLanguageExist) {
          this.responseData = JSON.parse(localStorage.getItem("LanguageTextV2"));
          for (var i = 0; i < response.length; i++) {
            this.responseData.push(response[i]);//pushing the changed language response to previous list
          }
          if (this.responseData) {
            localStorage.setItem('LanguageTextV2', JSON.stringify(this.responseData));
            window.location.reload();
          }
        }
        else {
          localStorage.setItem('LanguageTextV2', JSON.stringify(response));
        }
      }
    })
  }

  //#endregion


  public loginCart() {
    //this.userService.login(null).pipe(tap((login: IUser) => {
    // this.cartservice.totalCartItem.next(login.myCartItemCount);
    //})).subscribe(
    //);

  }



  public close(status): void {
    this.opened = false;
    this.changePasswordByOTP.isSuccess = false;
  }

  // TOGGLE LANGUAGE POPUP
  public onToggleLanguage(): void {
    this.showLanguage = !this.showLanguage;
  }

  public onToggleProfile(): void {
    this.showProfile = !this.showProfile;
  }



  public closeProfileDialog(): void {
    this.openedProfile = false;
    this.resetChangePasswordForm();
    this.disableChangePaswordSave = true;
  }
  public openProfileDialog(): void {
    this.openedProfile = true;
    this.showProfile = !this.showProfile;

    // PROFILE PASSWORD LOGIC
    this.passwordForm = this.fb.group({

      oldPassword: new FormControl(""),
      newpassword: new FormControl(""),
      confirmpassword: new FormControl(""),
      passwordGroup: this.fb.group(
        {
          newpassword: ['', [Validators.minLength(8)]],
          confirmpassword: ['', Validators.required],
        },
        { validator: passwordMatcher }
      ),

    });

    function passwordMatcher(
      c: AbstractControl
    ): { [key: string]: boolean } | null {
      const newpasswordControl = c.get('newpassword');
      const confirmpassword = c.get('confirmpassword');

      if (newpasswordControl.pristine || confirmpassword.pristine) {
        return null;
      }

      if (newpasswordControl.value === confirmpassword.value) {
        return null;
      }

      return { match: true };
    }
  }

  public openForgotPasswordDialog(): void {
    this.openedForgotPassword = !this.openedForgotPassword;
  }
  public openForgotPasswordOtpDialog(): void {
    this.openedForgotPasswordOtp = !this.openedForgotPasswordOtp;
  }

  public async closeForgotPasswordDialog() {
    this.headerText.ForgetPasswordEmail = "";
    this.headerText.ForgetPasswordUserName = "";
    this.headerText.forgetPasswordOTPMessageLbl = "";
    this.headerText.IsForgetpasswordResend = false;
    this.submittedOtp = false;

    if (this.forgotPasswordForm.invalid) {
      return;
    }
    this.openedForgotPasswordOtp = true;
    this.openedForgotPassword = false;
    //this.showSignIn = false;
    this.submitted = true;
    const body = {
      email: this.forgotPasswordForm.value.email,
      userName: this.forgotPasswordForm.value.userName
    }
    this.headerText.ForgetPasswordEmail = this.forgotPasswordForm.value.email;
    this.headerText.ForgetPasswordUserName = this.forgotPasswordForm.value.userName;
    this.headerText.IsForgetpasswordResend = false;
    this.headerText.forgetPasswordOTPMessageLbl = this.headerText.forgetPasswordOTPMessageLbl1 + this.headerText.ForgetPasswordEmail + this.headerText.forgetPasswordOTPMessageLbl2;
   // this.userService.ForgotPassword(body).subscribe();
    const response = await this.userService.ForgotPasswordResend(body);
    if (response.status) {
      this.openedForgotPasswordOtpSuccess = true;
    } else {
      this.openedForgotPasswordOtpSuccess = false;
    }
    this.forgotPasswordForm.reset();
    //this.router.navigate(['home']);
  }
  public async forgotPasswordOtpResend(): Promise<void> {
    const body = {
      email: this.headerText.ForgetPasswordEmail,
      userName: this.headerText.ForgetPasswordUserName
    }
    this.forgetPasswordInProcess = true;
    this.headerText.IsForgetpasswordResend = true;
    const response = await this.userService.ForgotPasswordResend(body);
    this.submittedOtp = true;
    this.forgetPasswordInProcess = false;
    this.headerText.forgetPasswordOTPValidationMessagelbl = "A Verification Code has been resent to the email address you provided";
  }

  public async submitForgotPasswordOTPDialog(): Promise<void> {
    if (this.forgotPasswordOtpForm.invalid) {
      return;
    }
    //this.openedForgotPasswordConfirmation = true;
    // this.openedForgotPasswordOtp = false;
    //this.showSignIn = false;

    const body = {
      Password: this.forgotPasswordOtpForm.value.Otp,
      email: this.headerText.ForgetPasswordEmail,
      userName: this.headerText.ForgetPasswordUserName,
    }
    this.forgetPasswordInProcess = true;
    this.headerText.IsForgetpasswordResend = false;
    const otpResponse = await this.userService.ConfirmForgotPasswordOtp(body);
    this.forgetPasswordInProcess = false;
    if (otpResponse.status) {
      this.changePasswordByOTPForm.reset();
      this.changePasswordByOTP.isSuccess = false;
      this.changePasswordByOTP.opened = true;
      this.openedForgotPasswordOtp = false;
      this.headerText.ForgetPasswordOTP = parseInt(this.forgotPasswordOtpForm.value.Otp);
      this.forgotPasswordOtpForm.reset();
    } else {
      this.submittedOtp = true;
      this.headerText.forgetPasswordOTPValidationMessagelbl = "The password you have entered does not match with the Verification Code sent to you via e-mail. Please try again or click 'Resend'";
    }
  }
  forgotPasswordCancel(): void {
    // this.submitted = false;
    // this.forgotPasswordForm.reset();
    this.showSignIn = false;
    this.openedForgotPassword = false;
    this.router.navigate(['home']);
    this.forgotPasswordForm.reset();
  }
  forgotPasswordOtpClose(): void {
    this.showSignIn = false;
    this.openedForgotPasswordOtp = false;
    this.router.navigate(['home']);
    this.forgotPasswordOtpForm.reset();
  }

  public closeForgotPasswordConfirmation() {
    this.openedForgotPasswordConfirmation = false;
    this.forgotPasswordForm.reset();
    this.router.navigate(['home']);
  }

  //public onSubmit(): void {
  //  // NOT IMPLEMENTED YET
  //}

  get f() {
    return this.forgotPasswordForm.controls;
  }

  onReset(): void {
    this.passwordForm.reset();
  }

  public get totalCartItem$() {
    return this.cartservice.totalCartItem;


  }
  gotoCart(routepath: string): void {

    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([routepath]); // navigate to same route
    });

    // {
    // queryParams: {
    //  categoryId: this.selectedCategory,
    //  searchstring: this.selectedItem,
    // },
    // }

  }


  public changePasswordDialog = {
    typeDataLoading: false,
    opened: false,
    newPasswordLbl: "New Password",
    oldPasswordLbl: "Old Password",
    confirmPasswordLbl: "Confirm New Password",
    isInvalidNewPassword: false,
    isInvalidConfirmPassword: false,
    isPasswordNotMatched: false,
    isPasswordFormatInValid: false,
    isPasswordSameAsOld: false,
    isInvalidOldPassword: false,
    confirmPasswordMatch: "Password and Confirm Password must be match.",
    passwordSameAsOld: "New Password and Old password cannot be same.",
    passwordFormatMatch: "Password must contain at least 14 characters, one special character(!@#$%^&*), one number and one UpperCase character.",
    isSubmitted: false,
    isValidForm: this.validateNewPasswordForm()
  };
  checkNewPassword() {
    const controls = this.passwordForm.controls;
    if (controls.newpassword.value) {
      const res = this.checkPassword(controls.newpassword.value);
      if (!res) {
        this.changePasswordDialog.isInvalidNewPassword = true;
        this.changePasswordDialog.isPasswordFormatInValid = true;
      } else {
        if (controls.oldPassword.value && controls.newpassword.value) {
          if ((controls.oldPassword.value) == (controls.newpassword.value)) {
            this.changePasswordDialog.isInvalidNewPassword = false;
            this.changePasswordDialog.isPasswordFormatInValid = false;
            this.changePasswordDialog.isPasswordSameAsOld = true;
            return;
          }
          else {
            this.changePasswordDialog.isPasswordSameAsOld = false;
          }
        }
        this.changePasswordDialog.isInvalidNewPassword = false;
        this.changePasswordDialog.isPasswordFormatInValid = false;
      }
    } else {
      if (this.changePasswordDialog.isSubmitted) {
        this.changePasswordDialog.isInvalidNewPassword = true;
      } else {
        this.changePasswordDialog.isPasswordFormatInValid = false;
        this.changePasswordDialog.isInvalidNewPassword = false;

      }
    }
  }

  public validateNewPasswordForm(): boolean {
    let isValid = true;
    if (!this.changePasswordDialog) {
      return;
    }
    // if (this.changePasswordDialog.isSubmitted) {
    const controls = this.passwordForm.controls;
    if (controls.oldPassword.value) {
      this.changePasswordDialog.isInvalidOldPassword = false;
    } else {
      this.changePasswordDialog.isInvalidOldPassword = true;
      isValid = false;
    }
    if (controls.newpassword.value) {
      const res = this.checkPassword(controls.newpassword.value);
      if (!res) {
        this.changePasswordDialog.isInvalidNewPassword = true;

        this.changePasswordDialog.isPasswordFormatInValid = true;
        isValid = false;
      } else {
        this.changePasswordDialog.isInvalidNewPassword = false;
        this.changePasswordDialog.isPasswordFormatInValid = false;
      }
    } else {
      this.changePasswordDialog.isInvalidNewPassword = true;
      isValid = false;
    }
    if (controls.confirmpassword.value) {
      this.changePasswordDialog.isInvalidConfirmPassword = false;
      if (controls.newpassword.value != controls.confirmpassword.value) {
        this.changePasswordDialog.isInvalidConfirmPassword = true;
        this.changePasswordDialog.isPasswordNotMatched = true;
        isValid = false;
      }
      else {
        this.changePasswordDialog.isInvalidConfirmPassword = false;
        this.changePasswordDialog.isPasswordNotMatched = false;
      }
    } else {
      this.changePasswordDialog.isInvalidConfirmPassword = true;
      isValid = false;
    }
    if (controls.oldPassword.value && controls.newpassword.value) {
      if ((controls.oldPassword.value) == (controls.newpassword.value)) {
        this.changePasswordDialog.isPasswordSameAsOld = true;
        this.changePasswordDialog.isInvalidNewPassword = true;
        isValid = false;
      }
      else {
        this.changePasswordDialog.isPasswordSameAsOld = false;
      }
    }
    //}
    return isValid;
  }
  public resetChangePasswordForm() {
    this.changePasswordDialog.isSubmitted = false;
    this.changePasswordDialog.isInvalidNewPassword = false;
    this.changePasswordDialog.isInvalidConfirmPassword = false;
    this.changePasswordDialog.isPasswordNotMatched = false;
    this.changePasswordDialog.isPasswordFormatInValid = false;
    this.changePasswordDialog.isPasswordSameAsOld = false;
    this.changePasswordDialog.isInvalidOldPassword = false;
    this.passwordForm.reset();
    this.infoMessage = new Info();
    this.saveNewPasswordInProcess = false;
    //this.changedFailed = false;
    //this.changedSuccess = false;
  }
  public checkPassword(password: string) {
    // let password = "";//pass password textbox value here
    var regEx = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[A-Z]).{14,}$/; //regex for atleast one special character, one number, one capital letter and atlease 14 character
    var isValid = regEx.test(password);//returns true or false
    console.log(isValid);
    return isValid;
  }

  //#region change default password
  passwordSaveInProcess: boolean;
  passwordSaveInProcessByOTP: boolean;
  public defaultPassword = {
    opened: false,
    newPasswordLbl: "New Password",
    confirmPasswordLbl: "Confirm New Password",
    isEmptyNewPassword: false,
    isEmptyConfirmPassword: false,
    isPasswordNotMatched: false,
    isPasswordFormatInValid: false,
    isSubmitted: false,
    confirmPasswordMatch: "Password and Confirm Password must be match.",
    passwordFormatMatch: "Password must contain at least 14 characters, one special character(!@#$%^&*), one number and one UpperCase character.",
  }
  public changePasswordByOTP = {
    opened: false,
    isSuccessOpened: false,
    newPasswordLbl: "New Password",
    confirmPasswordLbl: "Confirm New Password",
    isEmptyNewPassword: false,
    isEmptyConfirmPassword: false,
    isPasswordNotMatched: false,
    isPasswordFormatInValid: false,
    isSubmitted: false,
    isSuccess: false,
    //confirmPasswordMatch: "Password and Confirm Password must be match.",
    //passwordFormatMatch: "Password must contain at least 14 characters, one special character(!@#$%^&*), one number and one UpperCase character.",
  }
  closeDefaultPasswordDialog() {
    //logout
    this.userService.LogoutTrigger.next(true);
    this.resetDefaultPasswordChangeForm();
    this.disableForgotPassword = true;
  }
  closechangePasswordOTPDialog() {
    //logout
    this.userService.LogoutTrigger.next(true);
    this.resetDefaultPasswordChangeForm();
    this.changePasswordByOTP.opened = false;
    this.disableForgotPasswordOTP = true;
    this.changePasswordByOTP.isSuccessOpened = false;
  }
  resetDefaultPasswordChangeForm() {
    this.defaultPassword.isEmptyNewPassword = false,
      this.defaultPassword.isEmptyConfirmPassword = false,
      this.defaultPassword.isPasswordNotMatched = false,
      this.passwordSaveInProcess = false,
      this.defaultPassword.opened = false;
    this.defaultPasswordForm.reset();
  }
  resetchangePasswordByOTPForm() {
    this.changePasswordByOTP.isEmptyNewPassword = false,
      this.changePasswordByOTP.isEmptyConfirmPassword = false,
      this.changePasswordByOTP.isPasswordNotMatched = false,
      this.passwordSaveInProcessByOTP = false,
      this.changePasswordByOTP.opened = false;
    this.changePasswordByOTPForm.reset();
  }
  public validateDefaultPasswordForm(): boolean {
    let isValid = true;
    const controls = this.defaultPasswordForm.controls;
    if (controls.newPassword.value) {
      const res = this.checkPassword(controls.newPassword.value);
      if (!res) {
        this.defaultPassword.isPasswordFormatInValid = true;
        isValid = false;
      } else {
        this.defaultPassword.isEmptyNewPassword = false;
        this.defaultPassword.isPasswordFormatInValid = false;
      }
    } else {
      this.defaultPassword.isEmptyNewPassword = true;
      isValid = false;
    }
    //if (this.defaultPassword.isSubmitted) {
    if (controls.confirmPassword.value) {
      this.defaultPassword.isEmptyConfirmPassword = false;
      if (controls.newPassword.value != controls.confirmPassword.value) {
        this.defaultPassword.isPasswordNotMatched = true;
        isValid = false;
      }
      else {
        this.defaultPassword.isEmptyConfirmPassword = false;
        this.defaultPassword.isPasswordNotMatched = false;
      }
    } else {
      this.defaultPassword.isEmptyConfirmPassword = true;
      isValid = false;
    }
    //}
    return isValid;
  }

  public validatechangePasswordByOTPForm(): boolean {
    let isValid = true;
    const controls = this.changePasswordByOTPForm.controls;
    if (controls.newPassword.value) {
      const res = this.checkPassword(controls.newPassword.value);
      if (!res) {
        //this.changePasswordByOTP.isPasswordFormatInValid = true;
        isValid = false;
      } else {
        this.changePasswordByOTP.isEmptyNewPassword = false;
        //this.changePasswordByOTP.isPasswordFormatInValid = false;
      }
    } else {
      this.changePasswordByOTP.isEmptyNewPassword = true;
      isValid = false;
    }
    //if (this.defaultPassword.isSubmitted) {
    if (controls.confirmPassword.value) {
      this.changePasswordByOTP.isEmptyConfirmPassword = false;
      if (controls.newPassword.value != controls.confirmPassword.value) {
        //this.changePasswordByOTP.isPasswordNotMatched = true;
        isValid = false;
      }
      else {
        this.changePasswordByOTP.isEmptyConfirmPassword = false;
        //this.changePasswordByOTP.isPasswordNotMatched = false;
      }
    } else {
      this.changePasswordByOTP.isEmptyConfirmPassword = true;
      isValid = false;
    }
    //}
    return isValid;
  }
  disableForgotPassword = true;
  disableForgotPasswordOTP = true;
  checkDisabledForgotPassword() {
    if (this.validateDefaultPasswordForm()) {
      this.disableForgotPassword = false;
    }
    else {
      this.disableForgotPassword = true;
    }
    return;
  }
  checkDisabledForgotPasswordByOTP() {
    if (this.validatechangePasswordByOTPForm()) {
      this.disableForgotPasswordOTP = false;
    }
    else {
      this.disableForgotPasswordOTP = true;
    }
    return;
  }
  changeDefaultPassword() {
    this.defaultPassword.isSubmitted = true;
    if (!this.validateDefaultPasswordForm()) {
      return;
    }
    this.passwordSaveInProcess = true;
    const body = {
      newPassword: this.defaultPasswordForm.controls.newPassword.value,
      userName: this.userService.readUserObject.userName,
      isDefaultPasswordChanged: true
    }
    this.userService.changeDefaultPassword(body).subscribe(response => {
      this.resetDefaultPasswordChangeForm();
      this.showLoginAttempt = false;
      this.appNotifyService.notify(NotifyType.SUCCESS, 'Password updated successfully');
      this.showSearch = !this.showSearch;
      this.showGreeting = !this.showGreeting;
      this.showMenu = !this.showMenu;
      this.showLoginBridgeBlock = !this.showLoginBridgeBlock;
      this.showSpacer = !this.showSpacer;
      this.showSignIn = !this.showSignIn; // kendo popup
      this.showProfileIcon = !this.showProfileIcon;
      this.showCart = !this.showCart;
      this.signInText = false;
      this.signOutText = true;
      this.passwordSaveInProcess = false;
      this.disableForgotPassword = true;
    })
  }

  submitChangePasswordByOTP() {
    this.changePasswordByOTP.isSubmitted = true;
    if (!this.validatechangePasswordByOTPForm()) {
      return;
    }
    this.passwordSaveInProcessByOTP = true;
    const body = {
      newPassword: this.changePasswordByOTPForm.controls.newPassword.value,
      userName: this.headerText.ForgetPasswordUserName,
      ForgetPasswordOTP: this.headerText.ForgetPasswordOTP,
      isDefaultPasswordChanged: false
    }
    this.userService.changeDefaultPassword(body).subscribe(response => {
      this.appNotifyService.notify(NotifyType.SUCCESS, 'Password updated successfully');
      //logout
      this.passwordSaveInProcessByOTP = false;
      this.changePasswordByOTP.isSuccess = true;
      this.changePasswordByOTP.isSuccessOpened = true;
      this.userService.LogoutTrigger.next(true);
    })
  }
  //#endregion
  //#region Terms & Condition agreement
  inProgress: boolean;
  termsConditionAgreement = {
    opened: false,
    isRead: false,
  }
  closeTermsConditionDialog() {
    //logout
    this.userService.LogoutTrigger.next(true);
    this.termsConditionAgreement.opened = false;
  }
  openTermsCondition() {
    var tersConditionUrl = "";
    window.open("../../../../assets/docs/termsandcondition.pdf");
    this.termsConditionAgreement.isRead = true;
  }
  isAgree: boolean;
  termsConditionSubmit(type) {
    this.inProgress = true;
    if (type == 'agree') {
      this.isAgree = true;
    } else {
      this.isAgree = true;
    }
    //cgange name
    const body = {
      isAgree: this.isAgree,
      userName: this.userService.readUserObject.userName
    }
    this.userService.acceptTermConditions(body).subscribe(response => {
      //show success
      this.inProgress = false;
      this.termsConditionAgreement.opened = false;
    })
  }
  //#endregion

  closeWarningMessage() {
    this.openedwarningMessage = false;
  }

  //#region LOGIN
  showSignInBox() {
    this.showSignIn = true;
    this.openedwarningMessage = false;
  }
  hideSignInBox() {
    this.showSignIn = false;
  }


  public async login() {
    this.invalidUserCredential = "";
    this.loginAttemptMessage = "";
    this.showLoginAttempt = false;
    const loginBody: ILoginRequest = {
      password: this.userPassword,
      username: this.userId,
    };

    this.checkOutage();
    //this.userService.logout();
    const loginResponse = await this.userService.login(loginBody);

    if (!loginResponse) { this.invalidUserCredential = this.headerText.errorOccuredLbl; return; }
    if (!loginResponse.isValid) {
      switch (loginResponse.error) {
        case 'UserDoesNotExist':
          this.invalidUserCredential = this.headerText.incorrectUsernameLbl;
          break;
        case 'UserNotActive':
          this.invalidUserCredential = this.headerText.userNotActiveLbl;
          break;
        case 'IncorrectCred':
          this.invalidUserCredential = this.headerText.incorrectUsernameLbl;
          this.loginAttemptMessage = this.headerText.maxLoginAttemptLbl1 + " " + loginResponse.retryCount + " " + this.headerText.maxLoginAttemptLbl2 + " " + loginResponse.maxRetryCount + " " + this.headerText.maxLoginAttemptLbl3 + " " + loginBody.username;
          this.showLoginAttempt = true;
          break;
        case 'WarningMessage':
          this.invalidUserCredential = this.headerText.incorrectUsernameLbl;
          this.loginAttemptMessage = this.headerText.warningMessageLbl;
          this.showLoginAttempt = true;
          break;
        default:
          this.invalidUserCredential = this.headerText.incorrectUsernameLbl;
          this.loginAttemptMessage = this.headerText.maxLoginAttemptLbl1 + " " + loginResponse.retryCount + " " + this.headerText.maxLoginAttemptLbl2 + " " + loginResponse.maxRetryCount + " " + this.headerText.maxLoginAttemptLbl3 + " " + loginBody.username;
          this.showLoginAttempt = true;
          this.loginAttemptMessage = this.headerText.warningMessageLbl;
          break;
      }
      if (loginResponse.retryCount > 3) {
        this.openedwarningMessage = true;
        console.log('test login error', loginResponse.error);
      }
      return;
    }
    if (loginResponse.forceTermsAndConditions) {
      this.termsConditionAgreement.opened = true;
    }
    if (loginResponse.forcePasswordReset) {
      this.defaultPassword.opened = true;
    }
    this.userService.saveToken(loginResponse.token);
    //setTimeout(function () { /* snip */ }, 1000);
    const userDetails = await this.userService.getUserDetails();
    if (!userDetails) {
      this.invalidUserCredential = this.headerText.errorOccuredLbl; return;
    }
    this.userService.saveUserObject(userDetails);
    this.cartService.getItemCountInCart().subscribe();
    this.showSignIn = false;
    this.initAccess();
    //this.dummy.nativeElement.click();
    //this.setLanguageDataInLocalstorage(); //moving this method call to onInit bacause data need to store in localstorage before login.
    if (this.isAuthenticated) {
      this.showMenu = true;
      this.getAllCustomers();
    }
    //if logged in from PWA -- then add a log to DB--Start
    if (this.isMobile) {
      this.deviceInfo = this.deviceService.getDeviceInfo();
      var deviceDetails = this.deviceInfo.device + ", " + this.deviceInfo.os + "-" + this.deviceInfo.os_version
        + ", " + this.deviceInfo.browser + "-" + this.deviceInfo.browser_version;
      const logBody: IPWALoginRequest = {
        userName: this.userService.readUserObject.userName,
        deviceName: deviceDetails,
        deviceHight: this.scrHeight,
        deviceWidth: this.scrWidth
      };
      const loginResponse = this.userService.pwaUserLoginLog(logBody);
    }
    //if logged in from PWA -- then add a log to DB--End
    this.userService.fetchFreightEstimateFlag();
    this.userService.fetchFreightEstimateNoteFlag();
    const dbVersion = await this.userService.getTextVersion();
    const version = Number(localStorage.getItem('LanguageTextVersion'));
    if (version != dbVersion) {
      localStorage.setItem('LanguageTextVersion', dbVersion.toString())
      localStorage.removeItem("LanguageTextV2");
      this.setLanguageDataInLocalstorage();
    }
  }

  //#endregion
  //#region LOGOUT
  public logOut(): void {
    this.userService.logout();
    this.initAccess();
    //localStorage.setItem('language', 'eng'); //setting by default language as english
    //localStorage.removeItem('LanguageText'); //Clearing language translation data on sign out 
  }
  //#endregion
  //#region INIT
  isSystemUserAdmin: boolean;
  isAuthenticated: boolean = false;
  isCSR: boolean = false;
  isSuperAdmin: boolean = false;
  isMultiCustomerAccount: boolean = false;
  isCustomerAdmin: boolean = false;
  hasAccountSummaryAccess: boolean = false;
  subscription: Subscription;
  ngOnInit(): void {
    this.checkOutage();
    this.subscription = this.userService.LogoutTrigger.subscribe(hasChange => {
      if (hasChange) {
        this.logOut();
      }
    });
    this.initText();
    //remove old language key from local storage, this is a crude hack as of now
    localStorage.removeItem('LanguageText');
    this.languageList = JSON.parse(localStorage.getItem("LanguageTextV2"));
    if (!this.languageList) {
      this.setLanguageDataInLocalstorage(); //setting the language data into localstorage on page load
    }
    this.loadLanguageTranslationData();
    this.initAccess();
    this.initSignalR();
    this.initForm();
    if (this.isAuthenticated) {
      this.userId = this.userService.readUserObject.userName;
      this.getAllCustomers();
    }

    //(start) Afsana Dec 5th 2023 visual password requirements code changes
    this.changePasswordByOTPForm = this.fb.group({
      newPassword: ['', Validators.required],
      confirmPassword: ['', Validators.required],
    });
    this.changePasswordByOTPForm.get('newPassword').valueChanges.subscribe(() => {
      this.validatechangePasswordByOTPForm();
      this.validateNewPassword();
      if (!this.changePasswordByOTPForm.get('newPassword').value) {
        this.setCrossIcon(this.passwordMatchIcon);
      }
    });
    this.changePasswordByOTPForm.get('confirmPassword').valueChanges.subscribe(() => {
      this.validateConfirmPassword();
      this.validatechangePasswordByOTPForm();
    });

    this.setCrossIcon(this.minLengthIcon);
    this.setCrossIcon(this.upperCaseIcon);
    this.setCrossIcon(this.lowerCaseIcon);
    this.setCrossIcon(this.numberIcon);
    this.setCrossIcon(this.specialCharacterIcon);
    //(end) Afsana Dec 5th 2023 visual password requirements code changes

    //this.customerService.getAllCustomers().subscribe((data: IChangeCustomer[]) => {
    //  this.filteredCustomerItems = data;
    //});

  }
  //(start) Afsana Dec 5th 2023 visual password requirements code changes
  validateNewPassword(): void {
    const newPassword = this.changePasswordByOTPForm.get('newPassword').value;

    if (!newPassword) {
      this.setCrossIcon(this.minLengthIcon);
      this.setCrossIcon(this.upperCaseIcon);
      this.setCrossIcon(this.lowerCaseIcon);
      this.setCrossIcon(this.numberIcon);
      this.setCrossIcon(this.specialCharacterIcon);
      return;
    }

    this.validateRequirement('minLength', newPassword.length >= 14, this.minLengthIcon);
    this.validateRequirement('upperCase', /[A-Z]/.test(newPassword), this.upperCaseIcon);
    this.validateRequirement('lowerCase', /[a-z]/.test(newPassword), this.lowerCaseIcon);
    this.validateRequirement('number', /\d/.test(newPassword), this.numberIcon);
    this.validateRequirement('specialCharacter', /[!@#$%^&*]/.test(newPassword), this.specialCharacterIcon);
  }
  validateConfirmPassword(): void {
    const newPassword = this.changePasswordByOTPForm.get('newPassword').value;
    const confirmPassword = this.changePasswordByOTPForm.get('confirmPassword').value;

    if (!confirmPassword) {
      return;
    }

    let isPasswordMatched = false;
    if (newPassword === confirmPassword) {
      isPasswordMatched = true;
    }
    this.updateIcon(this.passwordMatchIcon, isPasswordMatched);
  }
  validateRequirement(requirementName: string, isValid: boolean, iconElement: ElementRef): void {
    if (!isValid) { this.setCrossIcon(iconElement); }
    else { this.setCheckMarkIcon(iconElement); }
  }
  setCrossIcon(iconElement: ElementRef): void {
    if (iconElement && iconElement.nativeElement) {
      this.renderer.addClass(iconElement.nativeElement, 'cross-icon');
      this.renderer.removeClass(iconElement.nativeElement, 'check-mark-icon');
    }
  }
  setCheckMarkIcon(iconElement: ElementRef): void {
    if (iconElement && iconElement.nativeElement) {
      this.renderer.addClass(iconElement.nativeElement, 'check-mark-icon');
      this.renderer.removeClass(iconElement.nativeElement, 'cross-icon');
    }
  }
  updateIcon(iconElement: ElementRef, isValid: boolean): void {
    if (iconElement && iconElement.nativeElement) {
      if (isValid) {
        this.setCheckMarkIcon(iconElement);
      } else {
        this.setCrossIcon(iconElement);
      }
    }
  }
  //(end) Afsana Dec 5th 2023 visual password requirements code changes

  convertTZ(date, tzString) {
    return new Date((typeof date === "string" ? new Date(date) : date).toLocaleString("en-US", { timeZone: tzString }));
  }
  checkOutage() {
    this.userService.GetOutageObj().subscribe((outageObj) => {
      var startDate = Date.parse(outageObj.startTime);
      var endDate = Date.parse(outageObj.endTime);
      if (startDate <= Date.parse(this.convertTZ(new Date(), 'America/Chicago').toString()) && endDate >= Date.parse(this.convertTZ(new Date(), 'America/Chicago').toString())) {
        this.userService.OutageObject.next(outageObj);
        return;
      }
    });


  }
  initText() {
    this.signInLanguageLabel = this.signInLanguage[0].eng;
    this.signOutLanguageLabel = this.signOutLanguage[0].eng;
    this.userIdLanguageLabel = this.userIdLanguage[0].eng;
    this.passWordLanguageLabel = this.passWordLanguage[0].eng;
    this.forgotPassWordLanguageLabel = this.forgotPassWordLanguage[0].eng;
    this.forgotPasswordEmailConfirmationLanguageLabel = this.forgotPasswordEmailConfirmationLanguage[0].eng;
    this.newUserLanguageLabel = this.newUserLanguage[0].eng;
    this.continueButtonLanguageLabel = this.continueButtonLanguage[0].eng;
    this.resetButtonLanguageLabel = this.resetButtonLanguage[0].eng;
    const islanguageExist = localStorage.getItem('language');
    if (!islanguageExist) {
      localStorage.setItem('language', 'eng'); // Set default Language to English 
    }
  }
  initSignalR() {
    this.signalRService.messageReceived.subscribe(msg => {
      if (msg) {
        this.displayMessage = true;
        this.broadCastMessage = msg
      }
      else {
        this.displayMessage = false;
      }
    });
  }
  initForm() {
    this.forgotPasswordForm = this.forgotPasswordEmail.group({
      email: ['', [Validators.required]],
      userName: ['', [Validators.required]]
    });
    this.forgotPasswordOtpForm = this.forgotPasswordOtp.group({
      Otp: ['', [Validators.required]],
    });
    this.defaultPasswordForm = this.fb.group({
      newPassword: new FormControl(""),
      confirmPassword: new FormControl("")
    });
    this.changePasswordByOTPForm = this.fb.group({
      newPassword: new FormControl(""),
      confirmPassword: new FormControl("")
    });
    this.forgotUsernameForm = this.forgotUsernameEmail.group({
      email: ['', [Validators.required]],
      userLastName: ['', [Validators.required]]
    });
  }
  initAccess() {
    this.isAuthenticated = this.userService.isAuthenticated();
    this.isCSR = this.userService.isCSR();
    this.isSuperAdmin = this.userService.isSuperAdmin();
    this.isMultiCustomerAccount = this.userService.isMultiCustomerAccount();
    this.isCustomerAdmin = this.userService.isCustomerAdmin();
    this.isVisibleManageCompany = this.userService.isVisibleManageCompany();
    this.hasAccountSummaryAccess = this.userService.hasAccessToAccountSummary();
    this.canManageAddress = this.userService.canManageAddress();
  }
  //#endregion

  //#region header component label declaration
  headerText = {
    signInLbl: "Sign In",
    signOutLbl: "Sign Out",
    userNameLbl: "Username",
    passwordLbl: "Password",
    forgetPasswordLbl: "Forgot Password",
    newUserLbl: "New User",
    incorrectUsernameLbl: "Incorrect username/password.",
    userNotActiveLbl: "Your account is not active. Please contact KawneerAdmin to enable your account.",
    maxLoginAttemptLbl1: "You have used",
    maxLoginAttemptLbl2: "of",
    maxLoginAttemptLbl3: "sign-in attempts allowed for user",
    errorOccuredLbl: "Sorry! an error occured. Please try again",
    warningMessageLbl: "If you are experiencing issues with your current password, please select the ‘Reset Password’ button below. After 5 failed sign‑in attempts, your account will be deactivated. If you wish to continue logging in with your current password, select ‘Continue’. Please note, this will be your final attempt.",
    resetPasswordLbl: "Reset Password",
    loggedInCustomerLbl: "You are logged in as Customer",
    changeCustomerLbl: "Change Customer",
    closeLbl: "Close",
    saveLbl: "Save",
    forgetPasswordUserNameMessageLbl1: "Enter the username of your KawneerDirect account",
    forgetPasswordMessageLbl1: "Enter the email address of your Kawneerdirect account",
    forgetPasswordOTPValidationMessagelbl: "The password you have entered does not match with the Verification Code sent to you via e-mail. Please try again or click 'Resend'",
    forgetPasswordOTPMessageLbl1: "We've sent a Verification Code to the ",
    forgetPasswordOTPMessageLbl2: " email you provided",
    forgetPasswordOTPLbl: "Enter Verification Code",
    changepwdmessage: "Your password updated successfully. Please log in with new password.",
    submitotpLbl: "Submit",
    ForgetPasswordEmail: "",
    ForgetPasswordUserName: "",
    ForgetPasswordOTP: 0,
    IsForgetpasswordResend: false,
    resendotpLbl: "Resend",
    closeotpLbl: "Close",
    forgetPasswordOTPEMail: "",
    forgetPasswordOTPMessageLbl: "", // forgetPasswordOTPMessageLbl1 + email +  forgetPasswordOTPMessageLbl2
    continueLbl: "Continue",
    cancelLbl: "Cancel",
    // (start) Afsana K50-1105-Part2 to changed wordings for the Thank you message
    thanksLbl: "Thank You!",
    newPasswordSentToMailLbl: "A Temporary Password will be sent to the email associated to your KawneerDirect account, if your username and email matches our records.",
    // (end) Afsana K50-1105-Part2 to changed wordings for the Thank you message
    okLbl: "Ok",
    loggedInLbl: "You are logged in as",
    accountDetailsForLbl: "Account Details for",
    nameLbl: "Name",
    changePasswordLbl: "Change Password",
    viewCmpLbl: "View/Print CMP",
    accountSummaryLbl: "Account Summary",
    manageCompanyLbl: 'Manage Company',
    manageAddressLbl: "Manage Address",
    manageAccountsLbl: "Manage Accounts",
    newPasswordLbl: "New Password",
    oldPasswordLbl: "Old Password",
    confirmPasswordLbl: "Confirm New Password",
    confirmPasswordMatchLbl: "Password and Confirm Password must be match.",
    passwordSameAsOldLbl: "New Password cannot be same as Old Password.",
    passwordFormatMatchLbl: "Password must contain at least 14 characters, one special character(!@#$%^&*), one number and one UpperCase character.",
    passwordChangeSuccessfulLbl: "Password Changed Successfully",
    passwordFailedLbl: "Changing password failed, because we couldn't match your old password or you have reused same password, which you had previously used.",
    // (start) Afsana K50-1105-Part2 changed words from "Change Default Password" to the "Enter New KawneerDirect Password"
    changeDefaultPasswordLbl: "Enter New KawneerDirect Password",
    changepwdokLbl: "Ok",
    changePasswordByOTPLbl: "Create New Password ",
    // (end) Afsana K50-1105-Part2 changed words from "Change Default Password" to the "Enter New KawneerDirect Password"
    passwordUpdateSuccessfulLbl: "Your password has been updated.",
    termsConditionTitle: "Terms and Conditions",
    agreeLbl: "I Agree",
    disagreeLbl: "I Disagree",
    forgetUserNameLbl: "Forgot Username",
    forgetUserNameUserLastNameMessageLbl1: "Enter the lastname of your Kawneerdirect account",
    forgetUserNameMessageLbl1: "Enter the email address of your Kawneerdirect account",
    userNameSentToMailLbl: "Your username has been sent to the email associated with your kawneerDirect account, if your lastname and email matches our records",
    termsConditionNote: "You must click on the Terms and Conditions link above and review terms before accepting",
    termsConditionMessage1: 'BY CLICKING THE "I AGREE" BUTTON BELOW, YOU AGREE THAT YOU HAVE READ, UNDERSTAND AND AGREE TO BE BOUND BY THESE TERMS. KAWNEER RESERVES THE RIGHT, WITH OR WITHOUT NOTICE, TO MAKE CHANGES TO THE TERMS AT ITS DISCRETION. YOUR CONTINUED USE OF ANY  PART  OF  THIS  WEBSITE  OR  ANY  SERVICE  CONSTITUTES  YOUR ACCEPTANCE  OF  SUCH  CHANGES  TO  THIS  AGREEMENT.  YOU  SHOULD REVIEW  THIS  AGREEMENT  PERIODICALLY  TO  DETERMINE  IF  ANY CHANGES  HAVE  BEEN  MADE.  THE  MOST  CURRENT  VERSION  OF  THIS AGREEMENT,  WHICH  SUPERSEDES  ALL  PREVIOUS  VERSIONS,  CAN  BE REVIEWED BY GOING TO ',
    termsConditionMessage2: 'The Owner of any customer hereby authorizes its employees, contractors or otherwise, to review and accept the Terms of Use by clicking “I Agree”. Per the Terms of Use, Owner is responsible and liable for use of the Website through access it provides to its employees, contractors or otherwise, directly or indirectly.',
    termsConditionTxt: 'Terms and Conditions',
  }
  //#endregion

  //#region Language translate
  loadLanguageTranslationData() {
    const controlNameList = [
      { controlName: "signInLbl" },
      { controlName: "signOutLbl" },
      { controlName: "userNameLbl" },
      { controlName: "passwordLbl" },
      { controlName: "forgetPasswordLbl" },
      { controlName: "newUserLbl" },
      { controlName: "incorrectUsernameLbl" },
      { controlName: "userNotActiveLbl" },
      { controlName: "maxLoginAttemptLbl1" },
      { controlName: "maxLoginAttemptLbl2" },
      { controlName: "maxLoginAttemptLbl3" },
      { controlName: "errorOccuredLbl" },
      { controlName: "warningMessageLbl" },
      { controlName: "resetPasswordLbl" },
      { controlName: "loggedInCustomerLbl" },
      { controlName: "changeCustomerLbl" },
      { controlName: "closeLbl" },
      { controlName: "saveLbl" },
      { controlName: "forgetPasswordMessageLbl1" },
      { controlName: "forgetPasswordOTPMessageLbl1" },
      { controlName: "forgetPasswordOTPMessageLbl2" },
      { controlName: "forgetPasswordOTPLbl" },
      { controlName: "submitotpLbl" },
      { controlName: "resendotpLbl" },
      { controlName: "closeotpLbl" },
      { controlName: "forgetPasswordOTPValidationMessagelbl" },
      { controlName: "continueLbl" },
      { controlName: "cancelLbl" },
      { controlName: "thanksLbl" },
      { controlName: "newPasswordSentToMailLbl" },
      { controlName: "okLbl" },
      { controlName: "loggedInLbl" },
      { controlName: "accountDetailsForLbl" },
      { controlName: "nameLbl" },
      { controlName: "changePasswordLbl" },
      { controlName: "viewCmpLbl" },
      { controlName: "accountSummaryLbl" },
      { controlName: "manageAddressLbl" },
      { controlName: "manageCompanyLbl" },
      { controlName: "manageAccountsLbl" },
      { controlName: "newPasswordLbl" },
      { controlName: "oldPasswordLbl" },
      { controlName: "confirmPasswordLbl" },
      { controlName: "confirmPasswordMatchLbl" },
      { controlName: "passwordFormatMatchLbl" },
      { controlName: "passwordChangeSuccessfulLbl" },
      { controlName: "passwordFailedLbl" },
      { controlName: "changeDefaultPasswordLbl" },
      { controlName: "changePasswordByOTPLbl" },
      { controlName: "passwordUpdateSuccessfulLbl" },
      { controlName: "termsConditionTitle" },
      { controlName: "agreeLbl" },
      { controlName: "changepwdokLbl" },
      { controlName: "disagreeLbl" },
      { controlName: "termsConditionNote" },
      { controlName: "termsConditionMessage1" },
      { controlName: "termsConditionMessage2" },
      { controlName: "termsConditionTxt" },



    ];
    const componentName = "header";
    const response = this.languageTranslation.getLanguageTranslationList(controlNameList, componentName);
    if (response.length > 0) {
      this.header = response[response.length - 1];
    } else {
      this.header = response;
    }
  }
  @HostListener('window:resize', ['$event'])
  getScreenSize(event?) {
    this.scrHeight = window.innerHeight;
    this.scrWidth = window.innerWidth;
    if (this.scrWidth <= 1024) {
      this.isMobile = true;
    }
    else {
      this.isMobile = false;
    }
  }
  anchorViewportLeave() {
    if (this.isMobile) {
      this.showSignIn = true;
    }
    else {
      this.showSignIn = false;
    }
  }
  //#endregion

  public openedForgotUsername = false; // forgot username dialog
  public openedForgotUsernameConfirmation = false; // forgot username confimation dialog
  public forgotUsernameForm: FormGroup;

  public openForgotUsernameDialog(): void {
    this.openedForgotUsername = !this.openedForgotUsername;
  }
  showIncorrectDetailsWarning: boolean = false;
  public closeForgotUsernameDialog(): void {
    this.showIncorrectDetailsWarning = false;
    if (this.forgotUsernameForm.invalid) {
      return;
    }
    this.openedForgotUsernameConfirmation = true;
    this.openedForgotUsername = false;
    this.showSignIn = false;
    this.submitted = true;
    const body = {
      email: this.forgotUsernameForm.value.email,
      userLastName: this.forgotUsernameForm.value.userLastName
    }
    this.userService.ForgotUsername(body).subscribe(res => {
      //if (res == "success") {
      this.openedForgotUsernameConfirmation = true;
      //}
    });
    this.router.navigate(['home']);
  }
  forgotUsernameCancel(): void {
    this.showSignIn = false;
    this.openedForgotUsername = false;
    this.router.navigate(['home']);
    this.forgotUsernameForm.reset();
  }
  public closeForgotUsernameConfirmation() {
    this.openedForgotUsernameConfirmation = false;
    this.forgotUsernameForm.reset();
    this.router.navigate(['home']);
  }
  get f1() {
    return this.forgotUsernameForm.controls;
  }
}
